import { render, staticRenderFns } from "./Permissions.vue?vue&type=template&id=751b6fec&"
import script from "./Permissions.vue?vue&type=script&lang=js&"
export * from "./Permissions.vue?vue&type=script&lang=js&"
import style0 from "./Permissions.vue?vue&type=style&index=0&id=751b6fec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports